import React, { useEffect, useState } from 'react';
import { Alert } from "react-bootstrap"
import { useParams } from "react-router-dom";
import LocalizedStrings from 'react-localization';
import { Helmet } from "react-helmet";

import { JobService, JobList, ClientLanguage, getClientLanguageAsString } from "../../../../Api";

let locStrings = new LocalizedStrings({
    de:
    {
        applicationSuccessfullyTransmittedInformal: "Deine Bewerbung wurde erfolgreich übermittelt.",
        applicationSuccessfullyTransmittedFormal: "Ihre Bewerbung wurde erfolgreich übermittelt.",
        applicationSuccessfullyTransmittedDetailsHeader: "Was passiert als Nächstes?",
        applicationSuccessfullyTransmittedDetailsInformal: "Nach einer Prüfung deiner Bewerbung durch die Personalabteilung melden wir uns schnellstmöglich bei dir! ",
        applicationSuccessfullyTransmittedDetailsFormal: "Nach einer Prüfung Ihrer Bewerbung durch die Personalabteilung melden wir uns schnellstmöglich bei Ihnen! "
    },
    en:
    {
        applicationSuccessfullyTransmittedInformal: "Your application has been transmitted successfully.",
        applicationSuccessfullyTransmittedFormal: "Your application has been transmitted successfully.",
        applicationSuccessfullyTransmittedDetailsHeader: "What happens next?",
        applicationSuccessfullyTransmittedDetailsInformal: "After your application has been checked by the personnel department, we will contact you as soon as possible! ",
        applicationSuccessfullyTransmittedDetailsFormal: "After your application has been checked by the personnel department, we will contact you as soon as possible! "
    }
});

interface SuccessViewProps {

}

let showContent = false;

export const SuccessView = (props: SuccessViewProps) => {
    const { tenant, listName } = useParams();
    const [jobList, setJobList] = useState<JobList>()
    const withsubmitTxtSuccessHeader = jobList?.submitApplicationSuccessHeader !== undefined && jobList?.submitApplicationSuccessHeader !== "" && jobList?.submitApplicationSuccessHeader !== null;
    const withsubmitTxtSuccessDetails = jobList?.submitApplicationText !== undefined && jobList?.submitApplicationText !== "" && jobList?.submitApplicationText !== null;
    const withsubmitTxt = withsubmitTxtSuccessHeader || withsubmitTxtSuccessDetails;
    const submitSuccessHeader = jobList?.submitApplicationSuccessHeader ?? '';
    const submitTxt = { __html: jobList?.submitApplicationText?.replace(/\n/g, '<br/>') ?? '' };

    setLanguage();

    function setLanguage(): void {
        if (jobList) {
            switch(jobList.clientLanguage) { 
                case ClientLanguage.German: { 
                   locStrings.setLanguage('de');
                   break; 
                } 
                case ClientLanguage.English: { 
                   locStrings.setLanguage('en'); 
                   break; 
                } 
                // Otherwise "props.clientLanguage" is "ClientLanguage.BrowserSetting" and language used is browser setting dependent.
            } 
        }
    }

    useEffect(() => {
        if (tenant && listName) {
            JobService.getJobs(tenant, listName, true).then(result => {
                if (result) {
                    showContent = true;
                    setJobList(result);
                }
            })
        }
    }, [listName, tenant])

    if (!showContent) {
        return (
            <> </>
        )
    }
    else {
        return (
            <>
                <Helmet>
                    {/* <!-- Meta Pixel Code --> */}
                    <script>
                    {
                        `!function(f,b,e,v,n,t,s)
                        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                        n.queue=[];t=b.createElement(e);t.async=!0;
                        t.src=v;s=b.getElementsByTagName(e)[0];
                        s.parentNode.insertBefore(t,s)}(window, document,'script',
                        'https://connect.facebook.net/en_US/fbevents.js');
                        fbq('init', '7167432393379174');
                        fbq('track', 'PageView');
                        fbq('track', 'Lead');` 
                    }</script>
                    <noscript>
                    {
                        `<img height="1" width="1" style="display:none"
                        src="https://www.facebook.com/tr?id=7167432393379174&ev=PageView&noscript=1"
                        />`
                    }</noscript>
                    {/* <!-- End Meta Pixel Code --> */}
                </Helmet>
            
                <Alert variant="success" style={{ marginTop: "30px" }}>

                    {withsubmitTxtSuccessHeader && <Alert.Heading>{submitSuccessHeader}</Alert.Heading>}
                    {!jobList?.formalAddressPronoun && !withsubmitTxt && <Alert.Heading>{locStrings.applicationSuccessfullyTransmittedInformal}</Alert.Heading>}
                    {jobList?.formalAddressPronoun && !withsubmitTxt && <Alert.Heading>{locStrings.applicationSuccessfullyTransmittedFormal}</Alert.Heading>}
                    {withsubmitTxtSuccessDetails && <div dangerouslySetInnerHTML={submitTxt}></div>}
                    <p>
                        {!withsubmitTxt && locStrings.applicationSuccessfullyTransmittedDetailsHeader}<br />
                        {!jobList?.formalAddressPronoun && !withsubmitTxt && <>{locStrings.applicationSuccessfullyTransmittedDetailsInformal}</>}
                        {jobList?.formalAddressPronoun && !withsubmitTxt && <>{locStrings.applicationSuccessfullyTransmittedDetailsFormal}</>}
                    </p>
                </Alert >
            </>
        )
    }
}